import axios from "axios";

export const listApp = data => axios("https://cost.vsat.cloud/c/api/v1/app", { params: data });
export const getUserinfo = () => axios("https://cost.vsat.cloud/c/api/v1/user/info");
